import * as React from 'react';
import { connect } from 'react-redux';

import {
    Button,
    Col,
    Container,
    Row
} from 'reactstrap';

import '../Main.scss';

import { ApplicationState } from '../../Store';
import { actionCreators as UIActionCreators, GetAddUsers } from '../../Store/UIState';
import { GetDetailedUsers, GetUsers, LoadAllDetailedUsers } from '../../Store/User';
import { GetPortalText, RetrieveText } from '../../Store/PortalAssets';

import { AddUsersModal } from './Users/AddUsersModal';

import { 
    DetailedUserResponse, 
    UserResponse,
    PortalTextCommon,
    PortalTextSettings,
} from '../../Models/Api/strongbox.financialportal';

import { BreadCrumbs } from '../BreadCrumbs/BreadCrumbs';
import { pathConstants } from '../../Utils/Constants';

import { InlineStylingValues, SettingsSectionIds } from '../../Utils/Constants';

import { UserManagement } from './Users/UserManagement';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faAdd,
} from '@awesome.me/kit-8a0d2fd588/icons/modules/sharp/light';

type InjectedReduxState = {
    showingAddUsers: boolean;
    users: UserResponse[];
    detailedUsers: DetailedUserResponse[];
    commonText?: PortalTextCommon;
    settingsText?: PortalTextSettings;
};

type InjectedActionCreators = typeof UIActionCreators;

type SettingsContainerProps = {
}

type Props = SettingsContainerProps & InjectedActionCreators & InjectedReduxState;

const SettingsContainerComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        commonText,
        SetAddUsers,
        settingsText,
        showingAddUsers,
        detailedUsers,
        SetPortalWorking,
        SetPortalIdle,
    } = props;

    const onAddUserDismiss = (): void => {
        SetAddUsers(false);
        LoadAllDetailedUsers((errorMsg: string) => {})
    }

    const loadSettingsResources = async (): Promise<void> => {
        const workingMsg = 'SettingsContainer:LoadResources';

        try {
            SetPortalWorking(workingMsg);
            await RetrieveText(SettingsSectionIds);
        } finally {
            SetPortalIdle(workingMsg);
        }
    }

    React.useEffect(() => {
        loadSettingsResources();

        // I want this to take effect on mount.
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [])

    return (
        <div
            style={{
                position: 'absolute',
                height: '90%',
                width: '100%',
                minWidth: '20px'
            }}
            className={`free-content-region`}
        >
            <div
                style={{
                    minWidth: '20px',
                    height: '100%'
                }}
                className={`contained-content control-region control-region-lender`}
            >
                <div style={{ height: '100%' }}>
                    <Container className={'portal-container-settings'} fluid>
                        { !!settingsText && (
                            <React.Fragment>
                                <Row 
                                    className={'bread-crumb-header-container'}
                                >
                                    <Col className={'vcentered-content-col'}>
                                        <BreadCrumbs
                                            crumbs={[
                                                {
                                                    content: commonText?.breadcrumbWorkspaceList || '',
                                                    link: pathConstants.home,
                                                },
                                                {
                                                    content: settingsText?.userManagementTab || '',
                                                }
                                            ]}
                                        />
                                    </Col>
                                    <Col className={'right-aligned-col'}>
                                        <Button
                                            className={'small'}
                                            onClick={() => SetAddUsers(true)}
                                            color="primary"
                                        >
                                            <FontAwesomeIcon style={{ marginRight: InlineStylingValues.IconSeparator }} icon={faAdd} />{commonText?.add || ''}
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <UserManagement />
                                    </Col>
                                </Row>
                            </React.Fragment>
                        )}
                    </Container>
                </div>
            </div>

            {showingAddUsers &&
                <AddUsersModal
                    dismissModal={onAddUserDismiss}
                    existingUsers={detailedUsers}
                />
            }
        </div>
    );
}

export const SettingsContainer = connect<InjectedReduxState, InjectedActionCreators, SettingsContainerProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            showingAddUsers: GetAddUsers(appState),
            users: GetUsers(appState),
            detailedUsers: GetDetailedUsers(appState),
            commonText: GetPortalText<PortalTextCommon>(appState, 'commonText'),
            settingsText: GetPortalText<PortalTextSettings>(appState, 'settings'),
        };

        return result;
    },
    {
        ...UIActionCreators,
    }
)(SettingsContainerComponent);

